import styled, { css } from 'styled-components';
import { hideScrollbars } from 'styles/utils/hideScrollbars';

export const HiddenScrollDiv = styled.div`
  ${() => css`
    ${hideScrollbars};
  `}
`;

// This is an attempt to start centralizing our styling
// Since a design system is being written it's best to start establishing common standardized elements text, divs, box, etc
// not in terms of styling but also in terms of topography
// By having common css and more detailed themes we avoid the use of "magic numbers", guesses from wireframes or any inconsistent steps (9px > 11px > 13.5px > 504px, etc)
// A common agreed overall components themes and styling limits also facilitate integration or migration from one framework to the pther without having
// to crawl through the entire code to make the same changes over and over again when for example, the style definition of a subtext changes

// TODO: We can discuss more about this
